import { useEffect, type ReactNode } from 'react';
import styles from './Modal.module.css';

interface Props {
  title: string;
  subtitle?: string;
  maxWidth?: number;
  onClose(): void;
  children: ReactNode;
  actions?: ReactNode;
}

export function Modal({ title, subtitle, maxWidth, onClose, children, actions }: Props) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.card}
        style={maxWidth ? { maxWidth: `${maxWidth}px` } : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.top}>
          <div>
            <h3 className={styles.title}>{title}</h3>
            {subtitle && <p className={styles.sub}>{subtitle}</p>}
          </div>
          <button className={styles.close} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={styles.body}>{children}</div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    </div>
  );
}
